/* eslint-disable @typescript-eslint/no-explicit-any */
import { FieldProperties } from "alurkerja-ui/dist/types";
import StatusFilterComponent from "./custom-filter-components/status-filter-component";
import DateFilterComponent from "./custom-filter-components/date-filter-component";
import TextFilterComponent from "./custom-filter-components/text-filter-component";

export function TableHeaderFilter({
  name,
  filterKey,
  fields,
  handleChangeFilterByColumns,
  defaultFilterValue,
}: {
  name: string;
  filterKey?: string;
  fields: { [x: string]: FieldProperties };
  handleChangeFilterByColumns: (key: string, value: any) => void;
  defaultFilterValue: any;
}) {
  /**
   * Handles the default filter value by updating the key with a new key.
   * If the current name matches the provided key, it checks if the default filter value
   * for the new key exists or is an empty string. If so, it assigns the value of the new key
   * to the original key and deletes the new key from the default filter value.
   *
   * @param {string} key - The original key to be updated.
   * @param {string} newKey - The new key whose value will replace the original key's value.
   */
  const handleDefaultFilterValue = (key: string, newKey: string) => {
    if (name === key) {
      if (defaultFilterValue?.[newKey] || defaultFilterValue?.[newKey] === "") {
        defaultFilterValue[key] = defaultFilterValue?.[newKey];
        delete defaultFilterValue?.[newKey];
      }
    }
  };

  filterMappings.forEach(({ key, newKey }) =>
    handleDefaultFilterValue(key, newKey),
  );

  if (filterKeyMultiOptions.includes(name)) {
    const listOptions = fields[name]?.select_options?.options?.map(
      (option) => ({
        label: option.label,
        value: option.key,
      }),
    );

    return (
      <StatusFilterComponent
        listOptions={listOptions}
        defaultFilterValue={defaultFilterValue}
        name={name}
        handleChangeFilterByColumns={handleChangeFilterByColumns}
        paramName={name === "status" ? undefined : name}
      />
    );
  }

  if (name === "active") {
    const listOptions = fields[name]?.select_options?.options?.map(
      (option) => ({
        label: option.label,
        value: option.key,
      }),
    );

    return (
      <StatusFilterComponent
        listOptions={listOptions}
        defaultFilterValue={defaultFilterValue}
        name={name}
        handleChangeFilterByColumns={handleChangeFilterByColumns}
        paramName="actives"
      />
    );
  }

  if (name === "oltType") {
    const listOptions = fields[name]?.select_options?.options?.map(
      (option) => ({
        label: option.label,
        value: option.key,
      }),
    );

    return (
      <StatusFilterComponent
        listOptions={listOptions}
        defaultFilterValue={defaultFilterValue}
        name={name}
        handleChangeFilterByColumns={handleChangeFilterByColumns}
        paramName="oltTypes"
      />
    );
  }

  if (name === "monthTargetString") {
    const listOptions = fields[name]?.select_options?.options?.map(
      (option) => ({
        label: option.label,
        value: option.key,
      }),
    );

    return (
      <StatusFilterComponent
        listOptions={listOptions}
        defaultFilterValue={defaultFilterValue}
        name={name}
        handleChangeFilterByColumns={handleChangeFilterByColumns}
        paramName="monthTargetString"
      />
    );
  }

  if (
    name === "createdDate" ||
    name === "updatedDate" ||
    name === "notification.createdDate"
  ) {
    return (
      <DateFilterComponent
        name={name}
        handleChangeFilterByColumns={handleChangeFilterByColumns}
      />
    );
  }

  if (name === "picVendor" || name === "picLinknet") {
    return (
      <TextFilterComponent
        defaultFilterValue={defaultFilterValue}
        name={name}
        handleChangeFilterByColumns={handleChangeFilterByColumns}
      />
    );
  }

  if (name === "monthTarget" || name === "monthTargetString") {
    return (
      <DateFilterComponent
        name={name}
        handleChangeFilterByColumns={handleChangeFilterByColumns}
        type={"month"}
      />
    );
  }

  if (name === "yearTarget") {
    return (
      <DateFilterComponent
        name={name}
        handleChangeFilterByColumns={handleChangeFilterByColumns}
        type={"year"}
      />
    );
  }

  return (
    <TextFilterComponent
      defaultFilterValue={defaultFilterValue}
      name={filterKey ?? name}
      handleChangeFilterByColumns={handleChangeFilterByColumns}
    />
  );
}

const filterMappings = [
  { key: "picVendor", newKey: "picVendor.username" },
  { key: "picLinknet", newKey: "picLinknet.username" },
  { key: "status", newKey: "statusRfsSubmissions" },
];

const filterKeyMultiOptions = [
  "status",
  "notification.type",
  "notification.module",
];
